/**
 * Tope HTTP en vuelo por app.
 * Capacidad objetivo: 6 vendedores + 1 admin + 1 oficina + 3 bodega (+ tienda ocasional)
 * ≈ 11 clientes. Hosting ~20 concurrentes → máx. 3 por app deja margen para SSE.
 */
const MAX_IN_FLIGHT = 3;
let inFlight = 0;
const waitQueue = [];

function pump() {
  while (inFlight < MAX_IN_FLIGHT && waitQueue.length) {
    const next = waitQueue.shift();
    next();
  }
}

export function gatedFetch(url, options) {
  return new Promise((resolve, reject) => {
    const start = () => {
      inFlight += 1;
      fetch(url, options)
        .then(resolve, reject)
        .finally(() => {
          inFlight -= 1;
          pump();
        });
    };
    if (inFlight < MAX_IN_FLIGHT) start();
    else waitQueue.push(start);
  });
}
